import { useEffect, useState } from "react";

import { DevicesProvider, useEditor } from "@grapesjs/react";
import { Button, Group } from "@mantine/core";
import { SECONDARY_COLOR } from "~/../../base-components/lib/theme/button";

import { PrettySegmentedControl } from "./BuilderLeftSidebar";

export const BuilderHeader = () => {
  const editor = useEditor();
  const { Commands, UndoManager } = editor;
  const [, setUpdateCounter] = useState(0);

  // Needed to rerender on updates
  useEffect(() => {
    const cmdEvent = "run stop";
    const updateEvent = "update";
    const updateCounter = () => setUpdateCounter((value) => value + 1);
    editor.on(cmdEvent, updateCounter);
    editor.on(updateEvent, updateCounter);

    return () => {
      editor.off(cmdEvent, updateCounter);
      editor.off(updateEvent, updateCounter);
    };
  }, []);

  return (
    <Group
      sx={{
        background: "var(--var-builder-panel-color)",
        borderBottom: "1px solid var(--mantine-color-gray-3)",
      }}
      p={12}
      noWrap
    >
      <Group
        noWrap
        spacing={0}
        sx={{
          flexBasis: "33%",
        }}
      >
        <Group spacing={"xs"}>
          <Button
            color={SECONDARY_COLOR}
            onClick={() =>
              Commands.isActive("core:component-outline")
                ? Commands.stop("core:component-outline")
                : Commands.run("core:component-outline")
            }
          >
            Outline
          </Button>

          <Button
            color={SECONDARY_COLOR}
            onClick={() =>
              Commands.isActive("hl:toggle-helpers")
                ? Commands.stop("hl:toggle-helpers")
                : Commands.run("hl:toggle-helpers")
            }
          >
            Helpers
          </Button>

          <Button
            color={SECONDARY_COLOR}
            onClick={() => Commands.run("core:open-code")}
          >
            Code
          </Button>
        </Group>
      </Group>

      <Group
        noWrap
        sx={{
          flexBasis: "34%",
          paddingRight: 84, // To account for sidebar width
        }}
        position="center"
      >
        <DevicesProvider>
          {({ selected, select, devices }) => (
            <PrettySegmentedControl
              value={selected}
              onChange={(value) => select(value)}
              radius={"sm"}
              data={[
                ...devices.map((device) => ({
                  label: device.getName(),
                  value: "" + device.id,
                })),
              ]}
            />
          )}
        </DevicesProvider>
        <Group spacing={4} noWrap>
          <Button
            color={SECONDARY_COLOR}
            disabled={UndoManager.hasUndo() === false}
            onClick={() => Commands.run("core:undo")}
          >
            Undo
          </Button>

          <Button
            color={SECONDARY_COLOR}
            disabled={UndoManager.hasRedo() === false}
            onClick={() => Commands.run("core:redo")}
          >
            Redo
          </Button>
        </Group>
      </Group>

      <Group
        noWrap
        sx={{
          flexBasis: "33%",
        }}
        position="right"
        spacing={"xs"}
      >
        <Button
          color={SECONDARY_COLOR}
          onClick={() => Commands.run("hl:import")}
        >
          Import
        </Button>

        <Button
          color={SECONDARY_COLOR}
          onClick={() => Commands.run("hl:export")}
        >
          Export
        </Button>

        <Button
          color={SECONDARY_COLOR}
          onClick={() => Commands.run("hl:preview")}
        >
          Preview
        </Button>

        <Button color={SECONDARY_COLOR} onClick={() => Commands.run("hl:save")}>
          Save
        </Button>
      </Group>
    </Group>
  );
};
